// ─────────────────────────────────────────────────────────────────────────────
// WORK STYLE SCREENER — Question Bank
// 40 Likert items (1=Strongly Disagree → 5=Strongly Agree)
// Science: IPIP-20 open domain · Big Five facets for frontline role prediction
// Dimensions: Reliability · Teamwork · Compliance · Stress Tolerance · Service
// Market: Warehousing · Logistics · Retail · Security · Blue collar at scale
// ─────────────────────────────────────────────────────────────────────────────
// R = Reliability & Conscientiousness (items 0-7)
// T = Teamwork & Agreeableness (items 8-15)
// C = Compliance & Rule-Following (items 16-23)
// S = Stress Tolerance (items 24-31)
// V = Service Orientation (items 32-39)
// Scoring: R items (reverse scored) marked with reverse:true

export const WORK_STYLE_ITEMS = [
  // ── RELIABILITY & CONSCIENTIOUSNESS ───────────────────────────────────────
  { id:"ws01", dim:"R", q:"I always complete tasks on time, even when it is difficult." },
  { id:"ws02", dim:"R", q:"I am someone who can always be counted on to show up when needed." },
  { id:"ws03", dim:"R", q:"I double-check my work before saying it is done." },
  { id:"ws04", dim:"R", q:"I keep the workspace tidy and organised without being asked." },
  { id:"ws05", dim:"R", q:"I find it easy to stick to a routine every day.", reverse:false },
  { id:"ws06", dim:"R", q:"I sometimes leave tasks unfinished when I lose interest.", reverse:true },
  { id:"ws07", dim:"R", q:"I am careful not to make mistakes, even in repetitive work." },
  { id:"ws08", dim:"R", q:"When I commit to something, I follow through on it." },

  // ── TEAMWORK & AGREEABLENESS ──────────────────────────────────────────────
  { id:"ws09", dim:"T", q:"I enjoy working as part of a team." },
  { id:"ws10", dim:"T", q:"I am happy to help a colleague even when I am busy." },
  { id:"ws11", dim:"T", q:"I find it easy to get along with people from different backgrounds." },
  { id:"ws12", dim:"T", q:"I avoid arguments and prefer to keep things peaceful at work." },
  { id:"ws13", dim:"T", q:"I sometimes find it difficult to work closely with others.", reverse:true },
  { id:"ws14", dim:"T", q:"I listen carefully before giving my opinion." },
  { id:"ws15", dim:"T", q:"I share credit for team successes with my colleagues." },
  { id:"ws16", dim:"T", q:"I am willing to adjust my plans to help the team succeed." },

  // ── COMPLIANCE & RULE-FOLLOWING ───────────────────────────────────────────
  { id:"ws17", dim:"C", q:"I always follow safety rules, even when no one is watching." },
  { id:"ws18", dim:"C", q:"I follow company procedures even when I think a shortcut would be faster." },
  { id:"ws19", dim:"C", q:"I report safety concerns immediately instead of ignoring them." },
  { id:"ws20", dim:"C", q:"I wear required protective equipment without needing to be reminded." },
  { id:"ws21", dim:"C", q:"I sometimes bend the rules if I think it will get the job done faster.", reverse:true },
  { id:"ws22", dim:"C", q:"I follow instructions from my supervisor even when I do not fully agree." },
  { id:"ws23", dim:"C", q:"I take data protection and confidentiality rules seriously." },
  { id:"ws24", dim:"C", q:"I always follow the correct process, even for tasks I have done many times before." },

  // ── STRESS TOLERANCE ──────────────────────────────────────────────────────
  { id:"ws25", dim:"S", q:"I stay calm and focused when the pace of work picks up suddenly." },
  { id:"ws26", dim:"S", q:"I can handle doing the same task for long periods without losing concentration." },
  { id:"ws27", dim:"S", q:"I do not get easily frustrated when things go wrong at work." },
  { id:"ws28", dim:"S", q:"When I am under pressure, I still perform at the same standard." },
  { id:"ws29", dim:"S", q:"I sometimes feel overwhelmed when there is too much to do at once.", reverse:true },
  { id:"ws30", dim:"S", q:"I bounce back quickly after a difficult day at work." },
  { id:"ws31", dim:"S", q:"Physical or repetitive work does not bother me over long shifts." },
  { id:"ws32", dim:"S", q:"I find it easy to concentrate even in noisy or busy environments." },

  // ── SERVICE ORIENTATION ───────────────────────────────────────────────────
  { id:"ws33", dim:"V", q:"I take pride in providing good service to customers or members of the public." },
  { id:"ws34", dim:"V", q:"I remain polite and patient even with difficult or demanding customers." },
  { id:"ws35", dim:"V", q:"I genuinely enjoy helping people, even as part of a routine job." },
  { id:"ws36", dim:"V", q:"When a customer has a complaint, I try to understand their concern before responding." },
  { id:"ws37", dim:"V", q:"I find customer-facing work draining and prefer to work alone.", reverse:true },
  { id:"ws38", dim:"V", q:"I take customer feedback seriously and try to improve based on it." },
  { id:"ws39", dim:"V", q:"I am friendly and approachable even at the end of a long shift." },
  { id:"ws40", dim:"V", q:"I go slightly beyond what is expected to make sure a customer is satisfied." },
];

export const WORK_STYLE_DIMS = {
  R: { id:"R", label:"Reliability",        fullLabel:"Reliability & Conscientiousness", icon:"✅", color:"#059669",
       desc:"Shows up consistently, completes tasks, maintains standards without supervision." },
  T: { id:"T", label:"Teamwork",           fullLabel:"Teamwork & Agreeableness",        icon:"🤝", color:"#1d4ed8",
       desc:"Works cooperatively, supportive of colleagues, adapts to team needs." },
  C: { id:"C", label:"Compliance",         fullLabel:"Compliance & Rule-Following",      icon:"📋", color:"#7c3aed",
       desc:"Follows safety rules, procedures and instructions consistently." },
  S: { id:"S", label:"Stress Tolerance",   fullLabel:"Stress Tolerance",                icon:"💪", color:"#0891b2",
       desc:"Maintains performance under pressure, handles repetitive work, stays calm." },
  V: { id:"V", label:"Service",            fullLabel:"Service Orientation",              icon:"⭐", color:"#d97706",
       desc:"Patient with customers, takes pride in service quality, friendly under pressure." },
};
